export function assertNever(value: never) {
  throw Error(
    `This codepath was supposed to be unreachable: but we received: ${value}`
  );
}
